type PodBatchResultsParams = {
  podId: string;
};

export const podBatchResults = ({ podId }: PodBatchResultsParams): string => {
  return `/pods/${podId}/batch-results`;
};

export const suggestedSearches = (): string => "/suggested-searches";
